export const getConsent = () => {
    return localStorage.getItem('allowGA');
}
